import React from "react";
import _ from "underscore";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import AtomDek from "components/source/atoms/atom-dek";
import AtomHed from "components/source/atoms/atom-hed";
import classNames from "classnames";
import Constants from "rtr-constants";
import FilterInputPairs from "components/source/new_taxonomy/filter-input-pairs";
import MaternityHelper from "helpers/maternity-helper";
import { isGridType } from "helpers/filter-helpers";
import { gridViewPropType } from "components/propTypes";

export class GridTopFiltersSize extends React.Component {
  static propTypes = {
    ctaText: PropTypes.string,
    dekText: PropTypes.string,
    gridView: gridViewPropType, //provided by globalStore
    hedText: PropTypes.string,
    maternityText: PropTypes.string,
    onChangeSizes: PropTypes.func,
    onClickMaternityText: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    userData: PropTypes.object,
    workingFilters: PropTypes.shape({
      canonicalSizes: PropTypes.array,
    }).isRequired,
  };

  state = {
    selectedSizes: this.props?.workingFilters?.canonicalSizes ?? [],
    enableSubmit: !_.isEmpty(this.props?.workingFilters?.canonicalSizes ?? []),
  };

  addSelectedSize = size => {
    return [].concat(this.state.selectedSizes).concat([size]);
  };

  isKidsGrid() {
    const { gridView } = this.props;
    return isGridType(gridView, "Kids");
  }

  removeSelectedSize = size => {
    return _.filter(this.state.selectedSizes.slice(0), s => s !== size);
  };

  onChange = e => {
    const { name, selected } = e;

    const newSizes = selected ? this.addSelectedSize(name) : this.removeSelectedSize(name);
    const enableSubmit = !_.isEmpty(newSizes);

    this.setState({
      selectedSizes: newSizes,
      enableSubmit: enableSubmit,
    });

    if (this.props.onChangeSizes) {
      this.props.onChangeSizes({ canonicalSizes: newSizes });
    }
  };

  onSubmit = e => {
    if (e?.preventDefault) {
      e.preventDefault();
    }

    const sizes = this.state.selectedSizes;
    this.props.onSubmit({ canonicalSizes: sizes });
  };

  renderMaternityText() {
    if (this.isKidsGrid()) {
      return;
    }
    if (!this.props.onClickMaternityText || !this.props.maternityText) {
      return;
    }

    return (
      <button className="maternity-text" type="button" onClick={this.props.onClickMaternityText}>
        {this.props.maternityText}
      </button>
    );
  }

  render() {
    const classes = classNames("grid-top-filters-size", {
      "maternity-size": MaternityHelper.inMaternityExperience(this.props.userData),
    });
    const contentClass = classNames("grid-top-filters__content", {
      maternity_text: this.props.maternityText,
    });

    let sizes;
    if (this.isKidsGrid()) {
      sizes = Constants.KidsCanonicalSizeYearValues;
    } else {
      sizes = Constants.CanonicalSizeValues;
    }

    return (
      <form className={classes}>
        <AtomHed text={this.props.hedText} />
        <AtomDek text={this.props.dekText} mobileText={this.props.dekText} />
        <div className={contentClass}>
          <div className="filter-fieldset canonicalSizes">
            <FilterInputPairs
              displayName="Size"
              filterOpen={true}
              filters={this.state.selectedSizes}
              keyName="canonicalSizes"
              onChange={this.onChange}
              values={sizes}
            />
            {this.renderMaternityText()}
          </div>
        </div>
        <div className="grid-top-filters__buttons">
          <button
            type="submit"
            disabled={!this.state.enableSubmit}
            className="btn"
            onClick={this.onSubmit}
            data-test-id="grid-size-save">
            {this.props.ctaText ? this.props.ctaText : "Save"}
          </button>
        </div>
      </form>
    );
  }
}

const mapStateToProps = state => {
  const { gridView } = state;

  return { gridView };
};

export default connect(mapStateToProps)(GridTopFiltersSize);
